import { useState } from 'preact/hooks'
import { acceptAndSign } from '@/services/api'
import { getProcessId } from '@/services/session'
import type { AcceptAndSignRequest } from '@cencert/mob-signature'
import { useTranslation } from 'react-i18next'

interface UseAcceptAndSignOptions {
  processId?: string
}

interface UseAcceptAndSignReturn {
  acceptAndSign: (options?: UseAcceptAndSignOptions) => Promise<void>
  isLoading: boolean
  error: string | null
}

export function useAcceptAndSign(): UseAcceptAndSignReturn {
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const handleAcceptAndSign = async (options?: UseAcceptAndSignOptions) => {
    const processId = options?.processId ?? getProcessId()
    if (!processId) {
      setError(t('documentAdd.errors.noIdProcess'))
      throw new Error('No process ID available')
    }

    setIsLoading(true)
    setError(null)

    const request: AcceptAndSignRequest = {
      processId,
    }

    await acceptAndSign(request, {
      onSuccess: () => {
        setIsLoading(false)
      },
      onError: err => {
        const errorMessage =
          err?.response?.data?.detail ?? t('summary.errors.signingError')
        setError(errorMessage)
        setIsLoading(false)
      },
    })
  }

  return {
    acceptAndSign: handleAcceptAndSign,
    isLoading,
    error,
  }
}
